import styled from 'styled-components'
import { colors } from '../utils/config'
import { Button } from '@bm-js/atlascloud-ui'
import DocumentCard from './DocumentCard'
import { FileEntryBM } from '@bm-js/atlascloud-shared'
import { useMedia } from '../utils/hooks'

const StyledDocumentInput = styled.div`
  .file-selector-image-container {
    margin-bottom: 0.5rem;
  }
  margin-bottom: 1rem;
  label,
  span {
    display: block;
  }
  label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${colors.gray700};
    font-weight: 500;
  }
  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.gray600};
    margin-bottom: 0.4rem;
  }
`

type Props = {
  onChange: (file: FileEntryBM | undefined) => void
  file: FileEntryBM | undefined
  label?: string
  desc?: string
  id?: string
}

const DocumentInput = ({ onChange, file, label, desc, id }: Props) => {
  const { openMediaSelector, closeMediaSelector } = useMedia()

  return (
    <StyledDocumentInput>
      {label && <label htmlFor={id}>{label}</label>}
      {desc && <span>{desc}</span>}
      <div className='file-selector-image-container'>
        {file ? <DocumentCard file={file} /> : null}
      </div>
      <Button
        onClick={() =>
          openMediaSelector({
            fileType: 'pdf',
            onSelect: (f) => {
              if (!f) return closeMediaSelector()
              onChange(f)
              closeMediaSelector()
            },
          })
        }
      >
        {file ? `Byt dokument` : `Välj dokument`}
      </Button>
    </StyledDocumentInput>
  )
}

export default DocumentInput
